export const roles = {
  PHONE_VALIDATION: 'phone_validation',
  DOCUMENT_OCR: 'document_ocr',
  DOCUMENT_OCR_RETRY: 'document_ocr_retry',
  LIVENESS: 'liveness',
  LIVENESS_RETRY: 'liveness_retry',
  QUIZ: 'quiz',
  FINISH: 'process_finished',
  PROCESS_FAILED: 'process_failed',
}
